type MetaProp =
  | 'fb:app_id'
  | 'og:url'
  | 'og:title'
  | 'og:type'
  | 'og:description'
  | 'og:image'
  | 'og:image:height'
  | 'og:image:width'
  | 'twitter:card';

type MetaContent = {
  'fb:app_id': string;
  'og:url': string;
  'og:title': string;
  'og:type': 'fitness.course' | 'website';
  'og:description': string;
  'og:image': string;
  'og:image:height': string;
  'og:image:width': string;
  'twitter:card': string;
};

export type ShareMetaTagType = { property?: MetaProp; content?: MetaContent[MetaProp] };

export const meta = <Prop extends MetaProp>(
  property: Prop,
  content: MetaContent[Prop],
) => {
  return { property, content };
};
